import React from 'react';
import VAT from './Vat';

/** Calendar-year counterpart to the VAT page (same workspace, full year instead of a bi-month). */
const AnnualReturns: React.FC = () => <VAT variant="annual" />;

export default AnnualReturns;
